@for (item of reasons; track item.id){
  <section class="bg-white dark:bg-gray-900 xl:ml-40 xl:mr-40" (click)="openReason(item.id)">
      <div class="grid gap-8 mb-6 lg:mb-16 ">
        <div class="items-center bg-gray-50 rounded-lg shadow sm:flex dark:bg-gray-800 dark:border-gray-700">
          <div class="p-5">
            <h3 class="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
              <a href="#">{{ item.title }}</a>
            </h3>
            <span class="text-gray-500 dark:text-gray-400">#{{item.topic}}</span>
            <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">{{item.description}}</p>
            <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">Von: {{item.ersteller}}</p>
          </div>
        </div>
      </div>
  </section>
}

